"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _shortid = _interopRequireDefault(require("shortid"));
// A passthrough method to prepend cnqr- to every automatically generated ID.
function generate() {
  // remove "-_"
  _shortid.default.characters('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$@');
  return "cnqr-".concat(_shortid.default.generate());
}
var _default = {
  generate: generate
};
exports.default = _default;